<script>
export default {
  name: "advertisementTwo"
};
</script>

<template>
  <el-row style="background-color: #2D2D2D; padding: 20px 0 20px 0;">
    <el-col :span="24" style="display: flex; justify-content: center">
      <img
        loading="lazy"
        src="../../assets/frame-02.png"
        style="width: 100%; height: 205px"
      />
    </el-col>
  </el-row>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/search/advertisementTwo.vue